import gql from 'graphql-tag'

export default ({ root, where }) => gql`
  mutation ($where: ${root}_bool_exp!) {
    delete_${root} (where: $where) {
      returning {
        id
      }
    }
  }
`
